import React, { useState, useEffect } from 'react';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { PageLayout } from '@src/common/PageLayout';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { FileUpload as FileUploadComp } from '@src/common/FileUploadV2';
import { Card } from '@uhg-abyss/web/ui/Card';
import { StateSelect } from '../Inputs/StateSelect/StateSelect';
import { ZipCode } from '../Inputs/ZipCode';
import { City } from '../Inputs/City';
import { StreetLine } from '../Inputs/StreetLine';

const Upload = styled('div', {
  '& [data-testid*="remove-icon"]': {
    marginLeft: '8%',
  },
});

const AlignZip = styled('div', {
  marginLeft: '10px',
});

const Space = styled('div', {
  marginBottom: '16px',
});

const Text = styled('p', {
  lineHeight: '22px',
});

const AlignCheckBox = styled('div', {
  marginBottom: '8px',
});

export const PrimaryBilling = () => {
  const form = useForm();
  const [isCheckboxDisabled, setCheckboxDisabled] = useState(true);
  const primaryServicingAddress = form.getValues('address.primaryServicing');
  const primaryBillingAddressProof = form.getValues(
    'address.primaryBillingProof'
  );
  const isSameAsServicing = form.getValues(
    'primaryBillingAddress.isSameAsServicing'
  );

  const handleChange = () => {
    if (!isSameAsServicing) {
      form.setValue('address.primaryBilling', primaryServicingAddress);
      if (!primaryBillingAddressProof) {
        form.setValue('address.primaryBillingProof', undefined, {
          errors: { required: true },
          touched: true,
        });
      }
    } else {
      form.setValue('address.primaryBilling', undefined);
      form.setValue('address.primaryBillingProof', undefined, {
        errors: { required: true },
        touched: true,
      });
    }
  };

  useEffect(() => {
    if (
      primaryServicingAddress &&
      primaryServicingAddress.city !== '' &&
      primaryServicingAddress.streetLine1 !== '' &&
      primaryServicingAddress.zipCode !== '' &&
      primaryServicingAddress.state &&
      primaryServicingAddress.state !== null
    ) {
      setCheckboxDisabled(false);
    } else {
      setCheckboxDisabled(true);
    }
  }, [JSON.stringify(primaryServicingAddress)]);
  // TODO come up with a better way to handle checkbox enable/disable

  return (
    <PageLayout>
      <Card
        header="Primary billing address"
        id="location-primary-service-label"
      >
        <Card.Section>
          <Text>Provide your practice's primary billing address.</Text>
          <AlignCheckBox>
            <Checkbox
              id="primary-billing-address-checkbox"
              model="primaryBillingAddress.isSameAsServicing"
              onChange={handleChange}
              isDisabled={isCheckboxDisabled}
            >
              Same as servicing address
            </Checkbox>
          </AlignCheckBox>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <StreetLine
                id="address-primary-billing-street-line-1-input"
                model="address.primaryBilling.streetLine1"
                label="Street line 1"
                streetLine="1"
                required
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <StreetLine
                id="address-primary-billing-street-line-2-input"
                model="address.primaryBilling.streetLine2"
                label="Street line 2"
                streetLine="2"
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <City
                id="primary-billing-address-city-input"
                model="address.primaryBilling.city"
                label="City"
                required
              />
            </Space>
          </Grid.Col>
          <Grid.Col span="80%" css={{ padding: '0px' }}>
            <Space>
              <Layout.Group>
                <StateSelect
                  model="address.primaryBilling.state"
                  id="address-primary-billing-state-select"
                  required
                />
                <AlignZip>
                  <ZipCode
                    id="primary-billing-address-zipCode-input"
                    model="address.primaryBilling.zipCode"
                    label="ZIP Code"
                    required
                  />
                </AlignZip>
              </Layout.Group>
            </Space>
          </Grid.Col>
          <Grid.Col span="100%" css={{ padding: '0px' }}>
            <Space>
              <Upload>
                <FileUploadComp
                  id="upload-primary-billing-address-proof-button"
                  model="address.primaryBillingProof"
                  label="Proof of billing address"
                  required
                />
              </Upload>
            </Space>
          </Grid.Col>
        </Card.Section>
      </Card>
    </PageLayout>
  );
};
